
window.reinitializeSlick = function () {
  var $slider = $('.wrap_upsell');

  if (!$slider.length) return;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.off('init reInit afterChange').on('init reInit afterChange', function (event, slick, currentSlide) {
    var i = (currentSlide || 0) + 1;
    $('.counter_upsell').text(i + '/' + slick.slideCount);
  });

  $slider.slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 800,
    fade: true,
    cssEase: 'linear'
  });

  $('.previous_btn_upsell')
    .off('click')
    .on('click', function () {
      $slider.slick('slickPrev');
    });

  $('.next_btn_upsell')
    .off('click')
    .on('click', function () {
      $slider.slick('slickNext');
    });
};
  reinitializeSlick();
      function updateqty(number, id) {
        let input = document.getElementById(id);
        let currentValue = parseInt(input.value) || 0;
            number = parseInt(number);
        let newValue = currentValue + number;
        if (newValue < 1) {
          newValue = 1;
        }
        input.value = newValue;
      }
    function addToCartVariant(id,vId) {
      let varId = $(`#product_variant__${id}`).val();
      let inputQty = $(`#qty-val-${id}`).val();
      if(!varId){
        varId = vId;
      } 
      if(!inputQty){
       inputQty = 1;
      }
      let formData = {
        id: varId,
        quantity: inputQty,
      };
      $.ajax({
        url: '/cart/add',
        type: 'POST',
        data: formData,
        success: function (response) {
          $.ajax({
            url: '/?section_id=cart-drawer',
            type: 'GET',
            dataType: 'html',
            success: function (carthtml) {
              $('cart-drawer').html($(carthtml).find('cart-drawer').html());
              reinitializeSlick();
            },
          });
        },
      });
    }
  

  
    let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

items.forEach(item => {

  let megaMenu = item.querySelector(".mega-menu__content");

  item.addEventListener("mouseenter", () => {

    // close other menus
    items.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.removeAttribute("open");
      }
    });

    // open current menu
    item.setAttribute("open", true);
  });

  // close when mouse leaves mega menu
  if (megaMenu) {
    megaMenu.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }

});

// close on outside click
document.addEventListener("click", (e) => {

  let menuWrapper = document.querySelector(".header__inline-menu");

  if (!menuWrapper.contains(e.target)) {
    items.forEach(item => {
      item.removeAttribute("open");
    });
  }

});

  


  

   $(document).ready(function() {
    $("[data-fancybox='gallery']").fancybox({
        thumbs: {
            autoStart: true
        },
        buttons: [
            "zoom",
            "slideShow",
            "close"
        ],
        transitionEffect: "slide",  // Animation type: "fade", "slide", "zoom-in-out", "circular", etc.
        transitionDuration: 500     // Duration of the animation in milliseconds
    });
});


 
     $(".gallery23").slick({
    speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
  arrows:false,
    slidesToShow: 5,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
            ]
});
    